var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6896",
    "data-name": "Group 6896",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.035,
    height: 21.262,
    viewBox: "0 0 19.035 21.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5192",
    "data-name": "Rectangle 5192",
    width: 19.035,
    height: 21.262,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6896-2",
    "data-name": "Group 6896",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9008",
    "data-name": "Path 9008",
    d: "M12.222,0H3.3A3.244,3.244,0,0,0,0,3.174V18.088a3.244,3.244,0,0,0,3.3,3.173h8.922a3.244,3.244,0,0,0,3.3-3.173V3.174A3.244,3.244,0,0,0,12.222,0m1.863,18.087a1.8,1.8,0,0,1-1.866,1.738H3.3a1.808,1.808,0,0,1-1.866-1.738V3.174A1.8,1.8,0,0,1,3.3,1.436h8.918a1.808,1.808,0,0,1,1.866,1.738V18.087Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9009",
    "data-name": "Path 9009",
    d: "M3.437,5.647H12.25a.718.718,0,1,0,.009-1.436H3.437a.718.718,0,1,0-.009,1.436Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9010",
    "data-name": "Path 9010",
    d: "M3.428,15.526a.718.718,0,1,0,.009,1.436H7.38a.718.718,0,1,0-.009-1.436H3.428Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M3.437,11.754a.718.718,0,0,0,0,1.435H7.371a.718.718,0,1,0,0-1.435H3.437",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9012",
    "data-name": "Path 9012",
    d: "M18.285,15.947a3.525,3.525,0,1,1-3.525-3.525,3.524,3.524,0,0,1,3.525,3.525",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9013",
    "data-name": "Path 9013",
    d: "M14.76,20.222a4.275,4.275,0,1,1,4.275-4.275,4.274,4.274,0,0,1-4.275,4.275m0-7.05a2.775,2.775,0,1,0,2.775,2.775,2.774,2.774,0,0,0-2.775-2.775",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9014",
    "data-name": "Path 9014",
    d: "M3.437,7.983H3.383a.718.718,0,0,0,.054,1.435H12.3a.718.718,0,0,0-.054-1.435Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9015",
    "data-name": "Path 9015",
    d: "M16.324,14.789,14.5,16.905a.076.076,0,0,1-.054.028.079.079,0,0,1-.057-.021l-1.262-1.147a.467.467,0,1,0-.629.691L13.764,17.6a1,1,0,0,0,.68.264h.063a1,1,0,0,0,.706-.351l1.82-2.116a.467.467,0,0,0-.709-.609Z",
    fill: "#003189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.0c234833e9544f963e3a98deca2dd293.svg";
export { ForwardRef as ReactComponent };